import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { withTheme } from "@material-ui/core/styles";

import {
  CARD_FORM,
  EDIT_CARD_MODAL_ID,
} from "features/planner/planner.constants";

import SimpleFormModal from "app/components/SimpleFormModal";
import { editCardOnSubmit } from "features/planner/planner.actions";
import DummyCardForm from "features/planner/components/Card/DummyCardForm";

class EditCardModal extends PureComponent {
  render() {
    const { theme, dispatchEditCardOnSubmit } = this.props;

    return (
      <SimpleFormModal
        Icon={null}
        title="Edit card"
        submitText="Save"
        component={DummyCardForm}
        modalId={EDIT_CARD_MODAL_ID}
        onSubmit={dispatchEditCardOnSubmit}
        form={{
          form: CARD_FORM.ID,
        }}
        FormProps={{
          theme,
        }}
      />
    );
  }
}

export default compose(
  connect(
    null,
    {
      dispatchEditCardOnSubmit: editCardOnSubmit,
    },
  ),
  withTheme,
)(EditCardModal);
